import Vue from 'vue'
import axios from 'axios'

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

axios.defaults.crossDomain = true;
// axios.defaults.withCredentials = true

const BASEURL = process.env.NODE_ENV === "development" ? 'http://api.checkpass.net' : "//api.checkpass.net"

const instance = axios.create({
  baseURL: BASEURL
});
const dev_php = ''
// const dev_php = process.env.NODE_ENV === "development" ? '/app_dev.php' : ''
Vue.prototype.Api = {
  BASEURL:BASEURL,
  region(id) { // 位置查询
    return instance.post(dev_php + '/an/dict/region/' + id)
  },
  payOrder(data) {   //订单支付
    return instance.post(dev_php + '/an/extraorder/payOrder.json',data)
  },
  query(oid) {  //订单查询
    return instance.get(dev_php + '/an/extraorder/' + oid)
  },
  querys() { // 字典表查询
    return instance.post(dev_php + '/an/dict/query')
  },
  getUploadOssInfo() { // oss文件上传参数
    return instance.post(dev_php + '/an/upload/getUploadOssInfo')
  },
  fileUrlValuation(formData) {
    return instance.post(dev_php + '/an/compute/fileUrlValuation',formData)
  },
  valuation(formData) {
    return instance.post(dev_php + '/an/compute/valuation.json', formData,{
      headers: {
        'Accept': 'application/json'
      }
    })
  },
  getSystems() {
    return instance.get(dev_php + "/rs/checksystems")
  },
  payStatus(oid) {  //轮询查订单
    return instance.get(dev_php + '/an/extraorder/' + oid + '/status')
  },
  preCreateOne(data) { // 生成订单
    return instance.post(dev_php + '/an/extraorder/preCreateOne',data)
  },

  getUploadOssInfov() {
    return instance.post(dev_php + '/an/upload/getUploadOssInfo')
  }
}





// WEBPACK FOOTER //
// ./src/assets/api.js